import { useContext, useMemo } from 'react';
import { authService } from './authService';
/**
 * Returns data from the user's auth state.
 */
export const useAuthState = () => {
 
    /**
     * Any stored data relevant to the user's auth state.
     */ 
    const contextData = useContext( authService.context );

    return useMemo( () => {
        return {
            ...contextData,
            permissions: authService.getPermissions(),
            hasPermission: authService.hasPermission.bind( authService )
        };
    }, [ contextData ] );
};
